import { federalReviewActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [federalReviewActions.loadSuccess]: (state, action) => {
        return action.payload.entities.federalReviewMsgs;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.federalReviewMsgs.entities.federalReviewMsgs ? action.payload.federalReviewMsgs.entities.federalReviewMsgs : {};
        return result;
    },
    [federalReviewActions.replySuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.nomxno === action.payload) {
                delete state[x.nono];
            }
        })
    },
    [federalReviewActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
    [federalReviewActions.closeNotificationSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.nomxno === action.payload.mxno) {
                delete state[x.nono];
            }
        })
    },


})


